import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1033CopyAnteileStatus: 'idle',
    startProcess1033CopyAnteileError: undefined as any,
    loadUserParamsProcess1033CopyAnteileStatus: 'idle',
    loadUserParamsProcess1033CopyAnteileError: undefined as any,

    process1033CopyAnteileList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1033CopyAnteile = createAsyncThunk('process1033CopyAnteileSlice/startProcess1033CopyAnteile', async ({ process1033CopyAnteile }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1033CopyAnteile/`,
        prepareData(process1033CopyAnteile),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1033CopyAnteileStatus } = getState().process1033CopyAnteileSlice
        return startProcess1033CopyAnteileStatus !== 'pending'
    }
})

export const loadUserParamsProcess1033CopyAnteile = createAsyncThunk('process1033CopyAnteileSlice/loadUserParamsProcess1033CopyAnteile', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1033CopyAnteile/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1033CopyAnteileStatus } = getState().process1033CopyAnteileSlice
        return loadUserParamsProcess1033CopyAnteileStatus !== 'pending'
    }
})

const Process1033CopyAnteileSlice = createSlice({
    name: 'process1033CopyAnteileSlice',
    initialState,
    reducers: {
        resetstartProcess1033CopyAnteile: (state) => {
            state.job = undefined
            state.startProcess1033CopyAnteileError = undefined
        },
        resetstartProcess1033CopyAnteileError: (state) => {
            state.startProcess1033CopyAnteileError = undefined
        },
        resetloadUserParamsProcess1033CopyAnteile: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1033CopyAnteileError = undefined
        },
        resetloadUserParamsProcess1033CopyAnteileError: (state) => {
            state.loadUserParamsProcess1033CopyAnteileError = undefined
        },
        removeFromProcess1033CopyAnteileListById: (state, action) => {
            state.process1033CopyAnteileList = state.process1033CopyAnteileList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1033CopyAnteileListByIds: (state, action) => {
            state.process1033CopyAnteileList = state.process1033CopyAnteileList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1033CopyAnteileList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1033CopyAnteileStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1033CopyAnteileList = []
            state.startProcess1033CopyAnteileStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1033CopyAnteile.pending, (state) => {
            state.startProcess1033CopyAnteileStatus = 'pending'
            state.startProcess1033CopyAnteileError = undefined
        })
        builder.addCase(startProcess1033CopyAnteile.fulfilled, (state, action) => {
            state.startProcess1033CopyAnteileStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1033CopyAnteile.rejected, (state, action) => {
            state.startProcess1033CopyAnteileStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1033CopyAnteileError = action.error.message
            } else {
                state.startProcess1033CopyAnteileError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1033CopyAnteile.pending, (state) => {
            state.loadUserParamsProcess1033CopyAnteileStatus = 'pending'
            state.loadUserParamsProcess1033CopyAnteileError = undefined
        })
        builder.addCase(loadUserParamsProcess1033CopyAnteile.fulfilled, (state, action) => {
            state.loadUserParamsProcess1033CopyAnteileStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1033CopyAnteile.rejected, (state, action) => {
            state.loadUserParamsProcess1033CopyAnteileStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1033CopyAnteileError = action.error.message
            } else {
                state.loadUserParamsProcess1033CopyAnteileError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1033CopyAnteile,
    resetstartProcess1033CopyAnteileError,
    resetloadUserParamsProcess1033CopyAnteile,
    resetloadUserParamsProcess1033CopyAnteileError,
    removeFromProcess1033CopyAnteileListById,
    removeFromProcess1033CopyAnteileListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1033CopyAnteileSlice.actions
export default Process1033CopyAnteileSlice.reducer
